{
  "RequestAvailabilityDialog": {
    "title": "请求可用性",
    "viaEmail": "通过邮件",
    "viaLink": "通过链接",
    "requestedDates": "请求日期",
    "requestedDatesHelper": "资源将在这些日期之间填写可用性",
    "addMessage": "添加消息",
    "addMessageHelper": "该消息将附在邮件中",
    "messagePlaceholder": "开始输入...",
    "next": "下一步",
    "generateLink": "生成链接",
    "generatedUrl": "生成的链接",
    "urlExpiresOn": "此链接将于 {{date}} 过期",
    "done": "完成",
    "copyUrl": "复制链接",
    "copied": "已复制",
    "back": "返回",
    "recipients": "收件人",
    "recipientsHelper": "确认谁应收到可用性请求邮件",
    "searchPlaceholder": "搜索并添加资源",
    "noSearchResults": "未找到资源",
    "noRecipients": "请至少添加一位收件人",
    "missingEmailsMessage": "这些资源没有邮箱。请在下方添加。",
    "recipientsCount": "{{count}} 位收件人",
    "recipientsCount_other": "{{count}} 位收件人",
    "removeRecipient": "移除收件人",
    "email": "邮箱",
    "noEmail": "无邮箱",
    "addEmail": "添加邮箱",
    "saveEmail": "保存邮箱",
    "resourceEmail": "资源邮箱",
    "emailPlaceholder": "输入邮箱",
    "confirmAndSend": "确认并发送",
    "emailPreviewTitle": "邮件预览",
    "emailPreviewHelper": "确认即将发送的请求",
    "emailPreviewGreeting": "你好，{{name}}，",
    "emailPreviewBody": "{{sender}} 在 {{company}} 想了解您何时有空。",
    "emailPreviewDatesLabel": "请求日期",
    "emailPreviewDateRange": "从 <start>{{startDate}}</start> 到 <end>{{endDate}}</end>",
    "emailPreviewCtaHint": "点击下方链接分享您的可用性。",
    "emailPreviewShareButton": "分享可用性",
    "emailPreviewExpiry": "此链接将在 28 天内有效，之后会过期。如果过期，请联系请求者获取新链接。",
    "sending": "发送中…",
    "sendSuccessTitle": "已发送 {{count}} 个请求",
    "sendSuccessTitle_other": "已发送 {{count}} 个请求",
    "unsavedChangesBeforeUnload": "可用性请求表单中有未保存的更改！",
    "dateRangeRequired": "请选择日期范围",
    "resourceRequired": "请选择资源",
    "emailRequired": "每位收件人都需要邮箱地址"
  }
}
